var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.415 6a.574.574 0 0 0-.397.176L11.999 17.195.981 6.176a.574.574 0 0 0-.408-.174.571.571 0 0 0-.4.982l11.422 11.422a.57.57 0 0 0 .808 0L23.825 6.984a.574.574 0 0 0 .132-.631.577.577 0 0 0-.542-.353Z"
  })));
};
export { SvgArrowDown as ReactComponent };